import { gql } from "@apollo/client";

export const ProductPriceQuery = gql`
  query ProductPrice(
    $productId: ID
    $configuration: [ProductConfigurationParameterInput!]
  ) {
    product(productId: $productId) {
      _id
      ... on SimpleProduct {
        simulatedPrice(configuration: $configuration) {
          amount
          currency
        }
        publicare {
          clientMigelConformity
          institutionalMigelConformity
        }
      }
    }
  }
`;

export const ProductQuery = gql`
  query Product($slug: String) {
    product(slug: $slug) {
      _id
      status
      sequence
      tags
      texts {
        _id
        slug
        variant1
        variant2
        title
        description
        labels
      }
      textsDe: texts(forceLocale: "de") {
        _id
        slug
      }
      textsFr: texts(forceLocale: "fr") {
        _id
        slug
      }
      textsIt: texts(forceLocale: "it") {
        _id
        slug
      }
      media {
        _id
        texts {
          _id
          title
        }
        file {
          _id
          url
        }
      }
      assortmentPaths {
        links {
          assortmentId
          assortmentTexts {
            _id
            title
            slug
          }
        }
      }
      siblings(limit: 50) {
        _id
        status
        sequence
        texts {
          _id
          slug
          variant1
          variant2
          title
        }
        ... on SimpleProduct {
          simulatedStocks {
            quantity
          }
          simulatedDispatches {
            earliestDelivery
          }
          sku
        }
      }
      ... on SimpleProduct {
        simulatedStocks {
          quantity
        }
        simulatedDispatches {
          earliestDelivery
        }
        sku
        publicareTranslatedSalesUnit
        salesQuantityPerUnit
        publicare {
          isNotReturnable
          cutting
          recipeType
          attributes
          swissmedic
          pharmaCode
          migel
          isOnlyForMedProfessionals
        }
      }
    }
  }
`;
